import { FC } from "react";
import type { RaffleSearch } from "features/search-wheel-raffle";
import { Pager } from "shared/ui";
import { useRafflesBoard } from "../../model/useRafflesBoard";
import { RaffleCardList } from "../RaffleCardList";

interface Props {
  // Поле поиска живёт в тулбаре модалки, здесь — только результаты.
  search: RaffleSearch;
  // Код из поиска передаём в деталь — для вступления в приватный.
  onOpenRaffle: (raffleId: number, inviteCode: string | null) => void;
}

const SearchResults: FC<Props> = ({ search, onOpenRaffle }) => (
  <RaffleCardList
    items={search.results}
    emptyText="Nothing found"
    isLoading={search.isSearching}
    errorMessage={search.errorMessage}
    onOpenRaffle={(raffleId) => onOpenRaffle(raffleId, search.inviteCode)}
  />
);

// Табло текущих розыгрышей; поиск находит и открытые, и закрытые.
export const RafflesBoard: FC<Props> = ({ search, onOpenRaffle }) => {
  const board = useRafflesBoard();

  if (search.isActive) {
    return <SearchResults search={search} onOpenRaffle={onOpenRaffle} />;
  }

  return (
    <>
      <RaffleCardList
        items={board.pageItems}
        emptyText="No active promos right now"
        isLoading={board.isLoading}
        errorMessage={board.errorMessage}
        onOpenRaffle={(raffleId) => onOpenRaffle(raffleId, null)}
      />
      <Pager page={board.page} pages={board.pages} onChange={board.setPage} />
    </>
  );
};
